<template>
  <cf-text-input
    v-model="internalValue"
    :disabled="disabled"
    type="text"
    :label="label"
    :name="name"
    :mask="mask"
    icon-class="fa-birthday-cake"
    inputmode="numeric"
    :placeholder="placeholder"
    autocomplete="bday"
    :show-as-optional="true"
    :validations="allValidations"
  />
</template>


<script>
  import localeDateInputOrder from '@/helpers/locale-date-input-order';

  import CfTextInput from '../cf-text-input/index.vue';


  export default {
    name: 'CfBirthdayInput',

    components: {
      CfTextInput
    },

    inject: {
      $validator: {
        from: '$validator'
      }
    },

    props: {
      disabled: {
        type: Boolean,
        default: false
      },

      includeYear: {
        type: Boolean,
        default: false
      },

      label: {
        type: String,
        default: 'Date of Birth'
      },

      name: {
        type: String,
        default: 'dateOfBirth'
      },

      required: {
        type: Boolean,
        default: false
      },

      modelValue: {
        type: String,
        default: null
      }
    },

    computed: {
      allValidations() {
        const validations = {
          required: this.required
        };

        if (this.includeYear) {
          validations.month_day_and_year = true;
        }
        else {
          validations.month_and_day = true;
        }

        return validations;
      },

      internalValue: {
        get() {
          return this.modelValue;
        },

        set(value) {
          this.$emit('update:modelValue', value);
        }
      },

      mask() {
        return this.includeYear ? 'monthDateAndYear' : 'monthAndDate';
      },

      placeholder() {
        const dayFirst = localeDateInputOrder() === 'DMY';
        const datePart = dayFirst ? 'DD/MM' : 'MM/DD';
        return this.includeYear ? `${datePart}/YYYY` : datePart;
      }
    }
  };
</script>
